import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Actions from '../actions'

import Topic from '../components/Topic'

class TopicContainer extends Component {
  render () {
    return (
      <Topic {...this.props} />
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    appMeta: state.appMeta,
    esdpMap: state.esdpMap,
    topic: state.esdpMap.topics.find((topic) => topic.id === ownProps.routeParams.topicId),
    responseState: state.responseState,
    resourcesRoot: state.prescriptionInfo.resourcesRoot,
    mediaServiceInfo: {mediaServiceUrl: state.prescriptionInfo.mediaServiceUrl, mediaHash: state.prescriptionInfo.mediaHash, mediaToken: state.prescriptionInfo.mediaToken},
    navigationInfo: state.navigationInfo
  }
}

export default connect(mapStateToProps, {...Actions})(TopicContainer)



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/containers/Topic.js